import styled from "styled-components";
import theme from "../../theme";

export const SidebarContainer = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 100vh;
  width: ${({ $collapsed }) =>
    $collapsed ? theme.layout.sidebarCollapsed : theme.layout.sidebar};
  display: flex;
  flex-direction: column;
  background: ${theme.color.surface};
  border-right: 1px solid ${theme.color.border};
  transition: width 0.2s ease, transform 0.2s ease;
  overflow: hidden;

  @media (max-width: ${theme.layout.breakpoint}) {
    width: ${theme.layout.sidebar};
    box-shadow: ${theme.shadow.lg};
  }
`;

export const LogoContainer = styled.div`
  height: ${theme.layout.header};
  flex: none;
  display: flex;
  align-items: center;
  padding: 0 ${({ $collapsed }) => ($collapsed ? "18px" : "20px")};
  border-bottom: 1px solid ${theme.color.border};

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
  }
`;

export const Menu = styled.nav`
  flex: 1;
  overflow-y: auto;
  padding: 16px 12px 24px;

  .group-label {
    padding: 0 12px;
    margin: 18px 0 8px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${theme.color.textFaint};
    white-space: nowrap;
    opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
    height: ${({ $collapsed }) => ($collapsed ? "0" : "auto")};
    margin-top: ${({ $collapsed }) => ($collapsed ? "12px" : "18px")};
    overflow: hidden;
    transition: opacity 0.15s ease;
  }

  &:first-of-type .group-label:first-child {
    margin-top: 0;
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  a {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: ${theme.radius.sm};
    font-size: ${theme.font.body};
    font-weight: 500;
    color: ${theme.color.textMuted};
    text-decoration: none;
    white-space: nowrap;
    transition: background 0.15s ease, color 0.15s ease;

    svg {
      flex: none;
      opacity: 0.85;
    }

    span {
      opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
      transition: opacity 0.15s ease;
    }

    &:hover {
      background: ${theme.color.surfaceAlt};
      color: ${theme.color.text};
    }

    &.active {
      background: ${theme.color.brandDark};
      color: ${theme.color.accent};
      box-shadow: ${theme.shadow.sm};
    }
  }
`;

export const SidebarFooter = styled.div`
  flex: none;
  margin: 0 12px 16px;
  padding: 14px;
  border-radius: ${theme.radius.md};
  background: ${theme.color.brandSoft};
  display: ${({ $collapsed }) => ($collapsed ? "none" : "block")};

  h4 {
    font-size: ${theme.font.small};
    font-weight: 600;
    color: ${theme.color.brandDark};
  }

  p {
    margin-top: 4px;
    font-size: ${theme.font.tiny};
    line-height: 1.5;
    color: ${theme.color.textMuted};
  }
`;

export const Backdrop = styled.div`
  display: none;

  @media (max-width: ${theme.layout.breakpoint}) {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 999;
    background: rgba(16, 24, 40, 0.4);
  }
`;
